"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RadioButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../../Icon"));

var _Components = require("../../Components");

var _Elements = require("../../Components/Elements");

var _memoizeFormElement = _interopRequireDefault(require("../../Utilities/memoizeFormElement"));

var _Form = require("../../Form");

var _Validations = require("../../Validations");

var _Utilities = require("../../Utilities");

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable react/require-default-props */

/* eslint-disable react/prop-types */
var RadioButton = function RadioButton(_ref) {
  var name = _ref.name,
      checked = _ref.checked,
      label = _ref.label,
      value = _ref.value,
      onChange = _ref.onChange,
      withIcon = _ref.withIcon,
      svg = _ref.svg,
      labelWidth = _ref.labelWidth,
      iconSize = _ref.iconSize,
      disabled = _ref.disabled;
  return (
    /*#__PURE__*/
    // TODO: Add onkeypress to ensure accessibility works in edge cases
    _react["default"].createElement(_Elements.StyledRadioButtonWrapper, {
      className: "radio-button-wrapper",
      onClick: function onClick(event) {
        if (!disabled) {
          onChange(event, value);
        }
      },
      disabled: disabled
    }, /*#__PURE__*/_react["default"].createElement(_Elements.StyledRadioButton, {
      role: "radio",
      name: name,
      checked: checked,
      "aria-checked": checked,
      value: value,
      id: "".concat(value, "-").concat(name),
      "aria-labelledby": "".concat(value, "-").concat(name, "-label")
    }, checked && /*#__PURE__*/_react["default"].createElement(_Elements.StyledRadioFill, null)), withIcon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      svg: svg,
      size: iconSize,
      mr: "xxs"
    }), /*#__PURE__*/_react["default"].createElement(_Components.Label, {
      label: label,
      name: name,
      id: "".concat(value, "-").concat(name, "-label"),
      labelWidth: labelWidth
    }))
  );
};

exports.RadioButton = RadioButton;
RadioButton.defaultProps = {
  iconSize: 'xs',
  disabled: false
};
RadioButton.propTypes = {
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape()]).isRequired,
  value: _propTypes["default"].string.isRequired,
  withIcon: _propTypes["default"].bool,
  svg: _propTypes["default"].string,
  iconSize: _propTypes["default"].oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  disabled: _propTypes["default"].bool // Other props are automatically passed from the <Radio> component

};

var Radio = function Radio(props) {
  var onChange = function onChange(event, value) {
    event.preventDefault();
    props.onChange({
      name: props.name,
      value: value
    });
  };

  var buildButtons = function buildButtons(children) {
    var value = props.value,
        name = props.name;
    return _react["default"].Children.map(children, function (child) {
      var checked = false;

      if (props.exact) {
        checked = value !== '' && child.props.value === value;
      } else {
        checked = child.props.value.includes(value) && value !== '';
      }

      return /*#__PURE__*/_react["default"].cloneElement(child, {
        name: name,
        checked: checked,
        onChange: onChange
      });
    });
  };

  var name = props.name,
      children = props.children,
      label = props.label,
      id = props.id,
      isRequired = props.isRequired,
      validations = props.validations,
      submitAttempted = props.submitAttempted,
      hideError = props.hideError;
  var errorId = (0, _Utilities.getFormErrorId)(validations, submitAttempted);
  return /*#__PURE__*/_react["default"].createElement(_Elements.RadioWrapper, {
    role: "radiogroup",
    name: name,
    "aria-labelledby": "".concat(id, "-label"),
    className: errorId ? 'form-error' : ''
  }, label && /*#__PURE__*/_react["default"].createElement(_Components.Label, {
    label: label,
    name: name,
    isRequired: isRequired,
    id: "".concat(id, "-label"),
    htmlFor: id
  }), /*#__PURE__*/_react["default"].createElement("div", null, buildButtons(children), !hideError && /*#__PURE__*/_react["default"].createElement(_Components.ErrorMessage, {
    id: errorId
  })));
};

Radio.defaultProps = {
  hideError: false
};
Radio.propTypes = {
  submitAttempted: _propTypes["default"].bool.isRequired,
  validations: _propTypes["default"].shape(),
  name: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  isRequired: _propTypes["default"].bool,
  exact: _propTypes["default"].bool,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].node]).isRequired,
  hideError: _propTypes["default"].bool
};
Radio.Validations = {
  required: _Validations.required
};
var MemoRadio = (0, _memoizeFormElement["default"])(Radio);

var _default = (0, _Form.asFormElement)(MemoRadio);

exports["default"] = _default;